import React, { useState, useEffect, useContext, useCallback, lazy, Suspense } from "react";
import axios from "../../../../axios/index";

import { Link, useHistory } from "react-router-dom";

// context
import { UserContext } from "../../../Context/UserContextProvider";

// Styles
import styles from "../DashboardFileManagement.module.css";
import archiveStyles from "../../DashboardArchivedFiles/ArchiveDetail/ArchiveDetail.module.css";

// Re Useable Components
import DashboardSideMenu from "../../DashboardReuseAbleComponents/DashboardSideMenu";
import DashboardHeader from "../../DashboardReuseAbleComponents/DashboardHeader";
import CardChart from "./CardChart";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import Counter from '../../DashboardReuseAbleComponents/Counter';
import parse from "html-react-parser";
import ShowProfileModal from "./ShowProfileModal";
// import LimitationModal from "./LimitationModal"
import AddToArchiveModal from "./AddToArchiveModal/AddToArchiveModal";
import AddToArchiveRequestModal from "./AddToArchiveModal/AddToArchiveRequestModal";
import { useLocation } from "react-router-dom";
import ReminderModal from "./ReminderModal/ReminderModal";
import FileTotalInfo from "../../DashboardReuseAbleComponents/FileTotalInfo";
import FileHouseDetail from "../../DashboardReuseAbleComponents/FileHouseDetail";
import FileHiddenAndLimitation from "../../DashboardReuseAbleComponents/FileHiddenAndLimitation";
import FileConsultants from "../../DashboardReuseAbleComponents/FileConsultants";
import FileOwnerAndConsultantData from "../../DashboardReuseAbleComponents/FileOwnerAndConsultantData";
import ArchiveData from "./ArchiveData";
import FileFacilities from "./FileFacilities";

//Images
import arrowIcon from "../../../../assets/img/DashboardICons/ArrowRounded.svg";
import eveIcon from "../../../../assets/img/DashboardICons/EyeIcon.svg";
import bgDocumentIcon from "../../../../assets/img/DashboardICons/documentBg.svg";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import CardLogs from "./CardLogs/CardLogs";
import SelectLandingModel from "./SelectLandings/SelectLandingsModel";

const CardDetail = () => {
  const [isShowSidebar, setIsShowSidebar] = useState(true);

  const [state, setState] = useState({
    state: useLocation()?.state?.state || null,
  });

  let [isSettingLandingHidden, setIsSettingLandingHidden] = useState(true);

  const history = useHistory();
  const { userToken, permissions, consultantData, userData } = useContext(UserContext);
  const { btnLoader, setBtnLoader } = useState(false);
  let [archiveReqData, setArchiveReqData] = useState(null);

  let [showLogs, setShowLogs] = useState(false);

  const [cardData, setCardData] = useState({
    detail: null,
    chartData1: null,
    chartData2: null,
    limit: null,
    limitConsultant: null,
    reminder: null,
    facilities: [],
    hiddenFile: false,
    mapData: { lat: 0, lng: 0 },
    archiveData: null,
    isLoading: true,
  });
  const [addedFacilitiesID, setAddedFacilitiesID] = useState([]);
  const [facilitiData, setFacilitiData] = useState();
  const [addedFacilities, setAddedFacilities] = useState([]);
  const [showModal, setShowModal] = useState({
    openLimitation: false,
    openProfile: false,
    openReminder: false,
    openArchive: false,
    openDelete: false,
    openRejectModal: false,
    openArchiveRequest: false,
  });
  const { id } = useParams();

  function haveCommonElements(arr1, arr2) {
    return arr1.some(item => arr2.includes(item));
  }

  let [categoriesData, setCategoriesData] = useState([]);

  useEffect(() => {
    axios.get("Category").then(res => {
      setCategoriesData(res.data.data);
    });
  }, []);

  const getDataHandler = useCallback(async () => {
    if (!consultantData.id) return;
    try {
      const [detailPromise, reminderPromise, limitPromise, archiveData, limitConsultant, archiveReq] = await Promise.all([
        state
          ? state.state.slug
            ? axios.get(`Estate/bySlugAdmin/${state.state.slug}`, { headers: { authorization: "Bearer " + userToken } })
            : axios.get(`Estate/${state.state.id}`, { headers: { authorization: "Bearer " + userToken } })
          : axios.get(`Estate/${state.state.id}`, { headers: { authorization: "Bearer " + userToken } }),
        axios.get(`Reminder/1/${state.state.id}`, { headers: { authorization: "Bearer " + userToken } }),
        userData.isConsultant &&
          axios.get(`ConsultantLimiting/ConsultantLimitFields?consultantId=${consultantData.id}&estateId=${state.state.id}`, {
            headers: { authorization: "Bearer " + userToken },
          }),
        state.isArchive && axios.get(`Archive/${state.state.id}`, { headers: { authorization: "Bearer " + userToken } }),
        userData.isConsultant &&
          axios.get(`ConsultantLimiting/ConsultantLimitFields?consultantId=${consultantData.id}`, { headers: { authorization: "Bearer " + userToken } }),
      ]);
      if (detailPromise.data.data) {
        const detailData = detailPromise.data.data;
        const status = (await detailData.rentPrice) === null || detailData.rentPrice === 0 ? 1 : 3;
        const status2 = (await detailData.rentPrice) === null || detailData.rentPrice === 0 ? 2 : 4;
        const [chartData1Promise, chartData2Promise] = await Promise.all([
          axios.get(`Estate/PriceChanges?estateId=${state.state.id}&priceType=${status}`, { headers: { authorization: "Bearer " + userToken } }),
          axios.get(`Estate/PriceChanges?estateId=${state.state.id}&priceType=${status2}`, { headers: { authorization: "Bearer " + userToken } }),
        ]);
        const getApiData = await axios.get(
          `Specification/GetList?categoryId=${detailPromise.data.data.categoryId}&subCategoryId=${detailPromise.data.data.subCategoryId}`,
          {
            headers: { authorization: "Bearer " + userToken },
          }
        );

        if (chartData1Promise.data.data) setCardData(prevState => ({ ...prevState, chartData1: chartData1Promise.data.data }));
        if (chartData2Promise.data.data) setCardData(prevState => ({ ...prevState, chartData2: chartData2Promise.data.data }));

        const limitItems =
          (await permissions?.find(item => item === 15)) === 15 ? null : limitPromise.data.data?.fileItems?.map(item => item.fieldName) ?? null;
        const limitItemsForConsultant =
          (await permissions?.find(item => item === 15)) === 15 ? null : limitConsultant.data.data?.fileItems?.map(item => item.fieldName) ?? null;
        const filteredFacilities = detailData.facilities?.split(",") ?? [];
        const isHiddenFile = detailData.status === 1 ? true : false;
        const locationData = detailData.address?.location?.split(",") ?? [];
        setAddedFacilities(filteredFacilities);
        setFacilitiData(getApiData.data.data);
        const filterdObjects = getApiData.data.data.filter(obj => {
          return filteredFacilities.includes(obj.title);
        });
        setAddedFacilitiesID(filterdObjects.map(item => item.id));

        setCardData(prevState => ({
          ...prevState,
          detail: detailData,
          limit: limitItems,
          limitConsultant: limitItemsForConsultant,
          facilities: filteredFacilities,
          hiddenFile: isHiddenFile,
          mapData: { lat: parseFloat(locationData[0]) ?? 0, lng: parseFloat(locationData[1]) ?? 0 },
          archiveData: archiveData?.data?.data || detailPromise?.data?.data?.archiveDetails,
        }));
      } else {
        throw "123";
      }

      if (reminderPromise.data.data) setCardData(prevState => ({ ...prevState, reminder: reminderPromise.data.data }));
      setCardData(prevState => ({ ...prevState, isLoading: false }));
    } catch (error) {
      // console.error(error);
    }
  }, [userToken, state, permissions]);

  useEffect(() => {
    let estateId = cardData?.detail?.id;
    let userId = userData?.id;

    axios
      .get("Archive/Request?EstateId=" + estateId + "&UserId=" + userId, {
        headers: {
          authorization: "Bearer " + userToken,
        },
      })
      .then(res => {
        setArchiveReqData(res.data.data[0]);
      });
  }, [cardData]);

  useEffect(() => {
    if (state.state == undefined) {
      setState(prev => ({
        state: {
          ...prev,
          id: id,
        },
      }));
    }
    getDataHandler();
  }, [getDataHandler]);

  const labels = cardData?.chartData2?.map(item => item.pChangeDate);
  const data = {
    responsive: true,
    labels: labels,
    datasets: [
      {
        label: cardData?.detail?.rentPrice === null || cardData?.detail?.rentPrice === 0 ? "تغییرات قیمت کل" : "تغییرات رهن",
        data: cardData?.chartData1?.map(item => item.price),
        borderColor: "#127442",
        backgroundColor: "#127442",
      },
      {
        label: cardData?.detail?.rentPrice === null || cardData?.detail?.rentPrice === 0 ? "تغییرات هر متر" : "تغییرات اجاره",
        data: cardData?.chartData2?.map(item => item.price),
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
    options: {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      },
    },
  };

  const CardSlider = lazy(() => import("./CardSlider"));
  const LimitationModal = lazy(() => import("./LimitationModal"));
  const RejectUserFileModal = lazy(() => import("./RejectUserFileModal"));

  if (state.state == undefined) {
    return;
  }

  function removeArchiveRequestHandler() {
    let reqId = archiveReqData.id;

    notify("در حال حذف درخواست", "success");
    axios
      .delete("Archive/Request?reqId=" + reqId, {
        headers: {
          authorization: "Bearer " + userToken,
        },
      })
      .catch(res => {
        notify("مشکلی در حذف درخواست به وجود آمد", "error");
      })
      .then(res => {
        window.location.reload();
      });
  }

  return (
    <>
      <ShowProfileModal
        show={showModal.openProfile}
        onHide={() =>
          setShowModal(prev => {
            return { ...prev, openProfile: false };
          })
        }
      />

      <AddToArchiveModal
        fileName={cardData.detail?.title || ""}
        show={showModal.openArchive}
        id={state.state.id}
        userToken={userToken}
        onHide={() =>
          setShowModal(prev => {
            return { ...prev, openArchive: false };
          })
        }
      />

      <AddToArchiveRequestModal
        show={showModal.openArchiveRequest}
        id={state.state.id}
        userToken={userToken}
        onHide={() =>
          setShowModal(prev => {
            return { ...prev, openArchive: false };
          })
        }></AddToArchiveRequestModal>

      <Suspense fallback={<div>Loading...</div>}>
        <LimitationModal
          show={showModal.openLimitation}
          onHide={() =>
            setShowModal(prev => {
              return { ...prev, openLimitation: false };
            })
          }
          id={state.state.id}
        />
      </Suspense>

      <Suspense fallback={<div>Loading...</div>}>
        <RejectUserFileModal
          show={showModal.openRejectModal}
          onHide={() =>
            setShowModal(prev => {
              return { ...prev, openRejectModal: false };
            })
          }
          fileId={state.state.id}
        />
      </Suspense>

      <ReminderModal
        show={showModal.openReminder}
        onHide={() =>
          setShowModal(prev => {
            return { ...prev, openReminder: false };
          })
        }
        id={state.state.id}
      />

      <ToastContainer
        position="top-right"
        autoClose={9000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      {cardData.isLoading ? (
        <div className={styles.loader_container}>
          <div className={styles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <SelectLandingModel
            close={() => {
              setIsSettingLandingHidden(true);
            }}
            hidden={isSettingLandingHidden}
            id={cardData.detail.id}></SelectLandingModel>
          <div className="row">
            <div className={isShowSidebar ? "col-md-9" : "col-md-12"}>
              <div className={`mt-3 px-0 ${styles.container}`}>
                <DashboardHeader
                  setIsShowSidebar={setIsShowSidebar}
                  isShowSidebar={isShowSidebar}
                  onClick={() =>
                    setShowModal(prev => {
                      return { ...prev, openProfile: true };
                    })
                  }
                />
                {permissions?.find(item => item === 19) === 19 ? (
                  <CardLogs id={cardData.detail.id} show={showLogs} hideFunction={setShowLogs}></CardLogs>
                ) : (
                  <></>
                )}

                <div className="py-2">
                  <div className="container-fluid">
                    <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3" dir="rtl">
                      {/* title */}
                      <div className="w-100 d-flex align-items-center justify-content-between flex-md-row flex-column flex-wrap mt-2 mb-2">
                        <div className="d-flex align-items-center justify-content-center mb-md-0 mb-2">
                          <a href="#" onClick={history.goBack}>
                            <img className="ms-2" src={arrowIcon} alt="icon" style={{ cursor: "pointer" }} />
                          </a>
                          {cardData?.limit?.find(item => item === "Title") || cardData?.limitConsultant?.find(item => item === "Title") ? (
                            <></>
                          ) : (
                            <div className={styles.text1}>{cardData.detail?.title}</div>
                          )}
                        </div>
                        <div className="d-flex align-items-center justify-content-center mt-md-0 mt-2">
                          <div
                            onClick={() =>
                              setShowModal(prev => {
                                return { ...prev, openReminder: true };
                              })
                            }
                            className="d-flex align-items-center justify-content-center ms-4">
                            {cardData.reminder?.isActive ? (
                              <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M3.25422 5.99921e-05L3.24168 0L3.22914 0.00035955L3.09836 0.00410964L3.08653 0.00444862L3.07473 0.00516017C1.44007 0.103688 0.250198 1.52099 0.253915 3.14163C0.25403 3.54755 0.327506 3.88404 0.469614 4.18938C0.60148 4.47272 0.781048 4.69961 0.920665 4.87602L0.923357 4.87942C1.00433 4.98338 1.1058 5.06965 1.22149 5.13285C1.33964 5.1974 1.47001 5.23646 1.60418 5.24752L1.63493 5.25005H1.66579H1.70704H1.71375L1.72046 5.24993C1.85874 5.24746 1.9946 5.21319 2.11751 5.1498C2.21546 5.09929 2.30309 5.03136 2.37624 4.94956L5.20025 2.17574L5.20416 2.1719L5.20801 2.16801C5.30467 2.07025 5.38018 1.95366 5.42985 1.82547C5.47927 1.69793 5.50206 1.56163 5.49682 1.42497C5.49179 1.28887 5.45892 1.15522 5.40021 1.0323C5.34121 0.908754 5.25739 0.798695 5.15397 0.708984L5.15013 0.705676C4.62163 0.253429 3.9498 0.00338799 3.25422 5.99921e-05ZM3.25828 1.50014C3.40186 1.50195 3.54325 1.52523 3.67805 1.56833L1.78419 3.42853C1.76611 3.35669 1.75392 3.265 1.75392 3.14068V3.1397L1.75391 3.13873C1.75156 2.23273 2.39865 1.55455 3.15447 1.50312L3.25828 1.50014ZM13.161 2.12805C11.6536 1.50363 9.99476 1.34025 8.39441 1.65858C6.79407 1.9769 5.32406 2.76264 4.17028 3.91642C3.0165 5.07021 2.23076 6.54022 1.91243 8.14056C1.5941 9.7409 1.75748 11.3997 2.3819 12.9072C2.70171 13.6793 3.1351 14.3939 3.6641 15.0292L1.97358 16.7197C1.68068 17.0126 1.68068 17.4875 1.97358 17.7804C2.26647 18.0733 2.74134 18.0733 3.03424 17.7804L4.72476 16.0899C4.94666 16.2746 5.17881 16.4482 5.42045 16.6097C6.77716 17.5162 8.37221 18.0001 10.0039 18.0001C11.9405 18.0001 13.8069 17.3191 15.2831 16.0899L16.9736 17.7804C17.2665 18.0733 17.7413 18.0733 18.0342 17.7804C18.3271 17.4875 18.3271 17.0126 18.0342 16.7197L16.3437 15.0292C17.573 13.5531 18.2539 11.6867 18.2539 9.75005C18.2539 8.11836 17.7701 6.5233 16.8635 5.1666C15.957 3.80989 14.6685 2.75247 13.161 2.12805ZM8.68705 3.12975C9.99642 2.8693 11.3536 3.00298 12.587 3.51387C13.8204 4.02476 14.8746 4.88992 15.6163 5.99996C16.358 7.10999 16.7539 8.41503 16.7539 9.75005C16.7539 11.5403 16.0428 13.2572 14.7769 14.523C13.511 15.7889 11.7941 16.5001 10.0039 16.5001C8.66889 16.5001 7.36384 16.1042 6.25381 15.3625C5.14378 14.6208 4.27861 13.5666 3.76772 12.3332C3.25683 11.0998 3.12316 9.74257 3.38361 8.4332C3.64406 7.12382 4.28693 5.92109 5.23094 4.97708C6.17494 4.03308 7.37768 3.3902 8.68705 3.12975ZM16.7596 0L16.7721 0.00035955L16.9029 0.00410964L16.9147 0.00444862L16.9266 0.00516017C18.5612 0.103688 19.7511 1.52101 19.7474 3.14166C19.7472 3.54757 19.6738 3.88405 19.5317 4.18938C19.3998 4.47271 19.2202 4.6996 19.0806 4.87602L19.0775 4.88C18.9962 4.98409 18.8943 5.07037 18.7782 5.13345C18.66 5.19762 18.5298 5.23635 18.3958 5.24716L18.3657 5.24958H18.3355H18.2942H18.2875L18.2808 5.24946C18.1425 5.24699 18.0067 5.21273 17.8838 5.14933C17.7858 5.09882 17.6982 5.0309 17.6251 4.94912L14.8011 2.17578L14.7971 2.17193L14.7933 2.16801C14.6966 2.07025 14.6211 1.95366 14.5714 1.82547C14.522 1.69792 14.4992 1.56161 14.5045 1.42494C14.5095 1.28883 14.5424 1.15521 14.6011 1.0323C14.6601 0.908762 14.7439 0.798701 14.8473 0.708984L14.8511 0.705676C15.3796 0.253429 16.0515 0.00338799 16.7471 5.99921e-05L16.7596 0ZM16.3233 1.56831L18.2172 3.42822C18.2352 3.35642 18.2474 3.26482 18.2474 3.14068V3.1397L18.2474 3.13873C18.2497 2.23273 17.6026 1.55455 16.8468 1.50312L16.743 1.50014C16.5994 1.50195 16.4581 1.52522 16.3233 1.56831ZM10.7539 4.50005C10.7539 4.08584 10.4181 3.75005 10.0039 3.75005C9.58969 3.75005 9.25391 4.08584 9.25391 4.50005V9.00005H6.25391C5.83969 9.00005 5.50391 9.33584 5.50391 9.75005C5.50391 10.1643 5.83969 10.5001 6.25391 10.5001H10.0039C10.4181 10.5001 10.7539 10.1643 10.7539 9.75005V4.50005Z"
                                  fill="#21409A"
                                />
                              </svg>
                            ) : (
                              <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M3.25373 0.00103655L3.24119 0.000976562L3.22865 0.00133611L3.09787 0.0050862L3.08605 0.00542518L3.07424 0.00613673C1.43958 0.104664 0.24971 1.52197 0.253427 3.14261C0.253542 3.54853 0.327018 3.88502 0.469126 4.19036C0.600991 4.47369 0.78056 4.70058 0.920177 4.877L0.922868 4.8804C1.00384 4.98436 1.10531 5.07062 1.221 5.13383C1.33915 5.19837 1.46952 5.23743 1.60369 5.24849L1.63444 5.25103H1.6653H1.70655H1.71326L1.71997 5.25091C1.85825 5.24843 1.99411 5.21417 2.11703 5.15078C2.21497 5.10027 2.3026 5.03233 2.37575 4.95054L5.19976 2.17672L5.20367 2.17288L5.20752 2.16899C5.30418 2.07123 5.37969 1.95463 5.42936 1.82645C5.47879 1.69891 5.50157 1.56261 5.49633 1.42595C5.4913 1.28984 5.45843 1.1562 5.39973 1.03328C5.34072 0.909731 5.2569 0.799672 5.15348 0.709961L5.14965 0.706653C4.62114 0.254406 3.94931 0.00436455 3.25373 0.00103655ZM3.25779 1.50112C3.40137 1.50293 3.54276 1.5262 3.67756 1.56931L1.7837 3.42951C1.76562 3.35767 1.75343 3.26597 1.75343 3.14165V3.14068L1.75342 3.13971C1.75108 2.23371 2.39816 1.55553 3.15398 1.50409L3.25779 1.50112ZM13.1606 2.12902C11.6531 1.5046 9.99427 1.34122 8.39393 1.65955C6.79358 1.97788 5.32357 2.76362 4.16979 3.9174C3.01601 5.07118 2.23027 6.54119 1.91194 8.14154C1.59361 9.74188 1.75699 11.4007 2.38142 12.9082C2.70122 13.6803 3.13461 14.3949 3.66361 15.0302L1.97309 16.7207C1.68019 17.0136 1.68019 17.4885 1.97309 17.7814C2.26598 18.0742 2.74085 18.0742 3.03375 17.7814L4.72427 16.0908C4.94617 16.2756 5.17832 16.4492 5.41997 16.6107C6.77667 17.5172 8.37173 18.001 10.0034 18.001C11.94 18.001 13.8065 17.3201 15.2826 16.0909L16.9731 17.7814C17.266 18.0742 17.7409 18.0742 18.0338 17.7814C18.3266 17.4885 18.3266 17.0136 18.0338 16.7207L16.3432 15.0302C17.5725 13.5541 18.2534 11.6876 18.2534 9.75103C18.2534 8.11933 17.7696 6.52428 16.863 5.16758C15.9565 3.81087 14.6681 2.75345 13.1606 2.12902ZM8.68656 3.13073C9.99593 2.87028 11.3531 3.00395 12.5865 3.51484C13.8199 4.02574 14.8741 4.8909 15.6158 6.00093C16.3575 7.11096 16.7534 8.41601 16.7534 9.75103C16.7534 11.5412 16.0423 13.2581 14.7764 14.524C13.5105 15.7899 11.7936 16.501 10.0034 16.501C8.6684 16.501 7.36335 16.1051 6.25332 15.3634C5.14329 14.6217 4.27813 13.5675 3.76723 12.3341C3.25634 11.1007 3.12267 9.74354 3.38312 8.43417C3.64357 7.1248 4.28645 5.92206 5.23045 4.97806C6.17446 4.03406 7.37719 3.39118 8.68656 3.13073ZM16.7591 0.000976562L16.7717 0.00133611L16.9024 0.0050862L16.9143 0.00542518L16.9261 0.00613673C18.5607 0.104665 19.7506 1.52198 19.7469 3.14263C19.7468 3.54854 19.6733 3.88503 19.5312 4.19036C19.3993 4.47369 19.2197 4.70058 19.0801 4.87699L19.077 4.88098C18.9957 4.98507 18.8938 5.07135 18.7777 5.13442C18.6595 5.19859 18.5293 5.23733 18.3953 5.24813L18.3652 5.25056H18.335H18.2938H18.287L18.2803 5.25044C18.142 5.24796 18.0062 5.2137 17.8833 5.15031C17.7853 5.0998 17.6977 5.03187 17.6246 4.9501L14.8006 2.17676L14.7967 2.1729L14.7928 2.16899C14.6961 2.07123 14.6206 1.95463 14.5709 1.82645C14.5215 1.6989 14.4987 1.56258 14.504 1.42591C14.509 1.28981 14.5419 1.15618 14.6006 1.03328C14.6596 0.909739 14.7434 0.799678 14.8468 0.709961L14.8507 0.706653C15.3792 0.254405 16.051 0.00436455 16.7466 0.00103655L16.7591 0.000976562ZM16.3228 1.56929L18.2167 3.4292C18.2347 3.3574 18.2469 3.26579 18.2469 3.14165V3.14068L18.2469 3.13971C18.2492 2.23371 17.6021 1.55553 16.8463 1.50409L16.7425 1.50112C16.599 1.50292 16.4576 1.5262 16.3228 1.56929ZM10.7534 4.50103C10.7534 4.08681 10.4176 3.75103 10.0034 3.75103C9.5892 3.75103 9.25342 4.08681 9.25342 4.50103V9.00103H6.25342C5.8392 9.00103 5.50342 9.33681 5.50342 9.75103C5.50342 10.1652 5.8392 10.501 6.25342 10.501H10.0034C10.4176 10.501 10.7534 10.1652 10.7534 9.75103V4.50103Z"
                                  fill="#8D8D8D"
                                />
                              </svg>
                            )}
                            <div className={`me-2 ${cardData.reminder?.isActive ? styles.card_savebtn_active : styles.card_savebtn}`}>یادآور</div>
                          </div>
                          <p className={`ms-3 ${styles.card_title_gray_line}`}></p>

                          <div className="d-flex align-items-center justify-content-center ms-md-4">
                            {cardData.detail?.isSavedByUser ? (
                              <svg
                                onClick={removeSaveHandler}
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="#21409A"
                                className="bi bi-bookmark-fill pointer"
                                viewBox="0 0 16 16">
                                <path d="M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z" />
                              </svg>
                            ) : (
                              <svg
                                onClick={saveCardHandler}
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-bookmark pointer"
                                viewBox="0 0 16 16">
                                <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z" />
                              </svg>
                            )}
                            <div className={`me-2 ${styles.card_savebtn}`}>ذخیره</div>
                          </div>
                          <p className={`ms-3 ${styles.card_title_gray_line}`}></p>

                          <div className="d-flex align-items-center justify-content-center ms-md-4">
                            <svg
                              onClick={() => setIsSettingLandingHidden(false)}
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 576 512"
                              width="16"
                              height="16"
                              fill="currentColor">
                              <path d="M512 48H64c-8.8 0-16 7.2-16 16V256H528V64c0-8.8-7.2-16-16-16zm64 208v48 48c0 35.3-28.7 64-64 64H364.3l8 48H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H352 224 152c-13.3 0-24-10.7-24-24s10.7-24 24-24h51.7l8-48H64c-35.3 0-64-28.7-64-64V304 256 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V256zM48 304v48c0 8.8 7.2 16 16 16H239.5c.3 0 .6 0 .8 0h95.2c.3 0 .6 0 .8 0H512c8.8 0 16-7.2 16-16V304H48zM252.3 464h71.3l-8-48H260.3l-8 48z" />
                            </svg>
                            <div onClick={() => setIsSettingLandingHidden(false)} className={`me-2 ${styles.card_savebtn}`}>
                              لندینگ
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* title */}

                      {cardData.reminder?.isActive && (
                        <div className="w-100 d-flex align-items-center justify-content-center my-4 flex-wrap">
                          <div
                            className={`w-75 d-flex align-items-center justify-content-md-between  justify-content-center py-2 px-5 flex-wrap ${styles.reminder_container}`}>
                            <div className="d-flex align-items-center justify-content-center flex-wrap">
                              <h5 className={`mb-0 ms-3 mt-2 mt-md-0 ${styles.reminder_title}`}>زمان یادآور:</h5>
                              <div className="my-md-0 my-3 d-flex align-items-center justify-content-center">
                                <div className={styles.reminder_title}>{cardData.reminder?.reminderDate?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</div>
                                <span className={`mx-3 ${styles.rounded_greeen}`}></span>
                                <div className={styles.reminder_title}>{cardData.reminder?.reminderTime?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</div>
                              </div>
                            </div>
                            <div className={`mb-2 mb-md-0 pointer ${styles.reminder_title}`} onClick={reminderHandler}>
                              غیرفعال سازی
                            </div>
                          </div>
                        </div>
                      )}

                      <Suspense fallback={<div>Loading...</div>}>
                        <CardSlider images={cardData.detail?.images.filter((val, index) => index != 0)} image={cardData.detail?.imageUrl} />
                      </Suspense>

                      <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap mt-3 mb-2 px-3">
                        <div className={styles.card_title}>{cardData.detail?.title}</div>

                        <div className={`d-flex align-items-center justify-content-evenly py-2 ${styles.card_view_info}`}>
                          <img src={eveIcon} alt="icon" />
                          <div className={styles.card_view_number}>{cardData.detail.visit?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])} بازدید</div>
                        </div>
                      </div>

                      {permissions?.find(item => item === 15) === 15 ||
                      permissions?.find(item => item === 16) === 16 ||
                      permissions?.find(item => item === 18) === 18 ? (
                        <div className="w-100 d-flex align-items-center justify-content-center flex-wrap mt-4 mb-4 px-3">
                          <Link
                            to={{
                              pathname: `/consultant-reports/${state.state.id}`,
                              state: cardData,
                            }}
                            className={`w-100 position-relative d-flex align-items-center justify-content-between ${styles.bg_ligh_green}`}>
                            <div className={`me-md-2 ms-0 ${styles.text_bold}`}>
                              <svg width="22" height="26" className="ms-2" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M9.16712 0.812514L9.17188 0.8125L13.9464 0.812501C14.22 0.812881 14.4907 0.867381 14.7431 0.97286C14.9955 1.07834 15.2245 1.23272 15.4169 1.42709L15.4189 1.42907L20.9604 7.06449C20.9607 7.06476 20.9609 7.06503 20.9612 7.0653C21.3466 7.45587 21.5626 7.98253 21.5625 8.53125C21.5625 8.53134 21.5625 8.53142 21.5625 8.53151V17.2656C21.5625 18.9275 20.2519 20.3125 18.5689 20.3125H15.875V22.1406C15.875 23.8025 14.5644 25.1875 12.8814 25.1875H3.43359C1.74868 25.1875 0.4375 23.8031 0.4375 22.1406V8.73438L0.437514 8.72962C0.442231 7.92426 0.764252 7.15322 1.33374 6.58374C1.90322 6.01425 2.67426 5.69223 3.47962 5.68751L3.48438 5.6875H6.125V3.85938L6.12501 3.85462C6.12973 3.04926 6.45175 2.27822 7.02124 1.70874C7.59072 1.13925 8.36176 0.817231 9.16712 0.812514ZM7.75 5.6875V3.86202C7.75276 3.4851 7.90371 3.12436 8.17029 2.85779C8.43686 2.59121 8.7976 2.44026 9.17452 2.4375H13.0312V7.10938C13.0312 7.11261 13.0313 7.11584 13.0313 7.11906C13.0383 7.7069 13.2749 8.26867 13.6906 8.68436C14.1063 9.10005 14.6681 9.33668 15.2559 9.34369C15.2574 9.34371 15.2589 9.34372 15.2603 9.34373C15.2621 9.34374 15.2639 9.34375 15.2656 9.34375H19.9375V17.2656C19.9375 18.0717 19.3133 18.6875 18.5689 18.6875H15.875V13.4132C15.875 13.4131 15.875 13.413 15.875 13.4129C15.875 13.4114 15.875 13.41 15.875 13.4085C15.875 13.4078 15.875 13.407 15.875 13.4062C15.875 13.4029 15.875 13.3995 15.8749 13.3961C15.8708 12.8525 15.6561 12.3314 15.2757 11.9424L15.2742 11.9408L9.73215 6.30484C9.73209 6.30477 9.73202 6.30471 9.73196 6.30464C9.54066 6.10964 9.31248 5.95465 9.0607 5.8487C8.80884 5.74271 8.5384 5.68792 8.26514 5.6875L7.75 5.6875ZM7.34375 7.3125V11.9844C7.34375 11.9876 7.34377 11.9908 7.34381 11.9941C7.35082 12.5819 7.58745 13.1437 8.00314 13.5594C8.41883 13.975 8.9806 14.2117 9.56844 14.2187C9.57166 14.2187 9.57489 14.2188 9.57812 14.2188H14.25V22.1406C14.25 22.9467 13.6258 23.5625 12.8814 23.5625H3.43359C2.68608 23.5625 2.0625 22.9461 2.0625 22.1406V8.73702C2.06526 8.3601 2.21621 7.99936 2.48279 7.73279C2.74936 7.46621 3.1101 7.31526 3.48702 7.3125H7.34375ZM13.6372 12.5938L8.96875 7.84615V11.9786C8.97169 12.1407 9.03741 12.2955 9.15219 12.4103C9.26696 12.5251 9.42176 12.5908 9.58394 12.5938H13.6372ZM19.3247 7.71875L14.6562 2.97115V7.10351C14.6592 7.26572 14.7249 7.42053 14.8397 7.53531C14.9545 7.65009 15.1093 7.71582 15.2715 7.71875H19.3247Z"
                                  fill="#8D8D8D"
                                />
                              </svg>
                              ثبت گزارشات
                            </div>
                            <Link
                              to={{
                                pathname: `/consultant-reports/${state.state.id}`,
                                state: cardData,
                              }}
                              className={`ms-md-5 ms-0 ${styles.link_btn}`}>
                              <svg className="me-2" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M7.47541 0.712087C7.84153 1.0782 7.84153 1.6718 7.47541 2.03791L2.51333 7L7.47541 11.9621C7.84153 12.3282 7.84153 12.9218 7.47541 13.2879C7.1093 13.654 6.5157 13.654 6.14959 13.2879L0.524587 7.66291C0.158471 7.2968 0.158471 6.7032 0.524587 6.33709L6.14959 0.712087C6.5157 0.345971 7.1093 0.345971 7.47541 0.712087Z"
                                  fill="#21409A"
                                />
                              </svg>
                            </Link>
                          </Link>
                        </div>
                      ) : (
                        <></>
                      )}

                      {/* total information */}
                      <FileTotalInfo
                        cardDetailData={cardData.detail}
                        limit={cardData.detail.userId == userData.id ? [] : cardData?.limit}
                        limitConsultant={cardData.detail.userId == userData.id ? [] : cardData?.limitConsultant}
                        notify={notify}
                      />
                      {/* total information */}

                      {/* house detail */}
                      <FileHouseDetail cardDetailData={cardData.detail} limit={cardData?.limit} limitConsultant={cardData?.limitConsultant} />
                      {/* house detail */}

                      {/* facilities */}
                      <FileFacilities
                        addedFacilities={addedFacilities}
                        setAddedFacilities={setAddedFacilities}
                        facilitiData={facilitiData}
                        itemID={facilitiData}
                        addedFacilitiesID={addedFacilitiesID}
                        setAddedFacilitiesID={setAddedFacilitiesID}
                        cardData={cardData.detail}
                      />
                      {/* facilities */}

                      {/* description */}
                      <div className="w-100 d-flex align-items-center justify-content-center flex-wrap mt-3 mb-3 px-3">
                        <div className={`w-100 p-3 text-right ${styles.about_ad}`}>
                          {cardData.detail?.description ? parse(`<body className=${styles.body_container}>${cardData.detail?.description}</body>`) : parse("")}
                        </div>
                      </div>
                      {/* description */}

                      {/* file found */}
                      {permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 18) === 18 ? (
                        <div className={`w-100 d-flex flex-column align-items-center justify-content-center flex-wrap mt-3 mb-3 px-3  ${styles.about_ad}`}>
                          <div className="w-100 p-3 text-right">فایل یابی از طریق :</div>
                          <div className={`w-100 p-3 text-right`}>
                            {cardData.detail?.searchType == 1
                              ? "دیوار"
                              : cardData.detail?.searchType == 2
                              ? "مشتری"
                              : cardData.detail?.searchType == 3
                              ? "مشتری حضوری"
                              : cardData.detail?.searchType == 4
                              ? "میدانی"
                              : cardData.detail?.searchType == 5
                              ? "تراکت"
                              : cardData.detail?.searchType == 6 && "پیامک"}
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                      {/* file found */}

                      {/* exchange notes */}
                      {/* {permissions?.find((item) => item === 15) === 15 || permissions?.find((item) => item === 18) === 18 || permissions?.find((item) => item === 16) === 16 ? */}
                      {cardData?.detail?.exchangeDescription && (
                        <div className="w-100 d-flex align-items-center justify-content-center flex-column flex-wrap mt-3 mb-2 px-3">
                          <div className="w-100 d-flex align-items-center justify-content-md-start justify-content-center">
                            <div className={styles.card_title}>
                              توضیحات {categoriesData.find(c => c.id == cardData.detail.categoryId)?.dealType == 1 ? "تبدیل" : "معاوضه"}
                            </div>
                          </div>
                          <div className="w-100 d-flex align-items-center justify-content-center flex-wrap mt-3 mb-3 px-3">
                            <div className={`w-100 p-3 text-right ${styles.about_ad}`}>{cardData?.detail?.exchangeDescription}</div>
                          </div>
                        </div>
                      )}
                      {/* : */}
                      {/* <></> */}
                      {/* } */}
                      {/* exchange notes */}

                      {permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 18) === 18 ? (
                        <FileConsultants id={state.state.id} slug={cardData.detail.slug} />
                      ) : (
                        <></>
                      )}

                      {/* Chart */}
                      <div className="w-100 d-flex align-items-center justify-content-center flex-wrap mt-4 mb-4 px-3">
                        <div className={`w-100 d-flex align-items-center justify-content-center flex-wrap mt-3 mb-3 px-2 ${styles.chart_container}`}>
                          <div className="w-100 d-flex align-items-center justify-content-md-start justify-content-center mb-4 me-3 mt-3">
                            <div className={styles.card_title}>نمودار تغییر قیمت</div>
                          </div>
                          <CardChart data={data} />
                        </div>
                      </div>
                      {/* Chart */}

                      {/* consultant report */}
                      {permissions?.find(item => item === 15) === 15 && (
                        <div className="w-100 d-flex align-items-center justify-content-center flex-wrap mt-4 mb-4 px-3">
                          <div className={`w-100 position-relative d-flex align-items-center justify-content-between ${styles.bg_ligh_green}`}>
                            <div className={`me-md-2 ms-0 ${styles.text_bold}`}>گزارشات مشاوران</div>
                            <Link
                              to={{
                                pathname: `/consultant-reports/${state.state.id}`,
                                state: cardData,
                              }}
                              className={`ms-md-5 ms-0 ${styles.link_btn}`}>
                              مشاهده
                              <svg className="me-2" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M7.47541 0.712087C7.84153 1.0782 7.84153 1.6718 7.47541 2.03791L2.51333 7L7.47541 11.9621C7.84153 12.3282 7.84153 12.9218 7.47541 13.2879C7.1093 13.654 6.5157 13.654 6.14959 13.2879L0.524587 7.66291C0.158471 7.2968 0.158471 6.7032 0.524587 6.33709L6.14959 0.712087C6.5157 0.345971 7.1093 0.345971 7.47541 0.712087Z"
                                  fill="#21409A"
                                />
                              </svg>
                            </Link>
                            <div className={styles.bg_icon}>
                              <img src={bgDocumentIcon} alt="icon" />
                            </div>
                          </div>
                        </div>
                      )}
                      {/* consultant report */}

                      {/* multiple file */}
                      {cardData?.detail?.isAnyChild && (
                        <div className="w-100 d-flex align-items-center justify-content-center flex-wrap mt-4 mb-4 px-3">
                          <div className={`w-100 position-relative d-flex align-items-center justify-content-between ${styles.bg_ligh_green}`}>
                            <div className={`me-md-2 ms-0 ${styles.text_bold}`}>زیرمجموعه های فایل</div>
                            <Link
                              to={{
                                pathname: `/multiple-story-cards`,
                                state: {
                                  state: cardData.detail,
                                  isArchive: cardData?.archiveData ? true : false,
                                  filterCardsByCategory: {
                                    forRent: cardData?.detail?.totalPrice ? false : true,
                                  },
                                },
                              }}
                              className={`ms-md-5 ms-0 ${styles.link_btn}`}>
                              مشاهده زیرمجموعه ها
                              <svg className="me-2" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M7.47541 0.712087C7.84153 1.0782 7.84153 1.6718 7.47541 2.03791L2.51333 7L7.47541 11.9621C7.84153 12.3282 7.84153 12.9218 7.47541 13.2879C7.1093 13.654 6.5157 13.654 6.14959 13.2879L0.524587 7.66291C0.158471 7.2968 0.158471 6.7032 0.524587 6.33709L6.14959 0.712087C6.5157 0.345971 7.1093 0.345971 7.47541 0.712087Z"
                                  fill="#21409A"
                                />
                              </svg>
                            </Link>
                          </div>
                        </div>
                      )}
                      {/* multiple file */}

                      {/* owner and consultant detail */}
                      {cardData.limit?.find(item => item === "ownerDetail") || cardData?.limitConsultant?.find(item => item === "ownerDetail") ? (
                        <></>
                      ) : (
                        <div className="w-100 d-flex flex-column align-items-start justify-content-center flex-wrap mt-4 mb-4 px-4">
                          <div className={styles.title}>اطلاعات مشاور و مالک</div>
                          <div className="w-100 d-flex align-items-center my-4 flex-wrap">
                            <div className={`d-flex align-items-center justify-content-start my-md-0 my-3 ${archiveStyles.archive_title_container}`}>
                              <div className={`d-flex align-items-center justify-content-center position-relative ${archiveStyles.line_green}`}>
                                <div className="d-flex flex-column align-items-start justify-content-start pe-2">
                                  <h5 className={styles.card_main_detail_text1}>نام مشاور</h5>
                                  <div className={styles.card_main_detail_text2}>{cardData.detail?.ownerDetail.fullName}</div>
                                </div>
                              </div>
                            </div>

                            <div className={`d-flex align-items-center justify-content-start my-md-0 my-3 ${archiveStyles.archive_title_container}`}>
                              <div className={`d-flex align-items-center justify-content-center position-relative ${archiveStyles.line_green}`}>
                                <div className="d-flex flex-column align-items-start justify-content-start pe-2">
                                  <h5 className={styles.card_main_detail_text1}>اطلاعات مشاور</h5>
                                  <div className={`d-flex align-items-center ${styles.card_main_detail_text2}`}>
                                    <h5 className={`m-0 ${styles.card_main_detail_text1}`}>
                                      {cardData.detail?.ownerDetail.phoneNumber.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}
                                    </h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {/* owner and consultant detail */}

                      {cardData.detail.userId == userData.id ||
                      permissions.find(item => item == 15) === 15 ||
                      (haveCommonElements(permissions, [18, 16]) &&
                        !(cardData?.limitConsultant?.find(item => item == "OwnerDetail") || cardData.limit?.find(item => item == "OwnerDetail"))) ? (
                        <FileOwnerAndConsultantData cardDetailData={cardData.detail} limitData={cardData.limit} />
                      ) : (
                        <></>
                      )}

                      {cardData?.archiveData && (
                        <ArchiveData archiveData={cardData.archiveData} reminderHandler={archiveReminderHandle} limits={cardData?.limit} />
                      )}

                      {/* Hidden and Limitation */}
                      {permissions?.find(item => item === 19) === 19 ||
                      permissions?.find(item => item === 15) === 15 ||
                      cardData.detail.userId == userData.id ? (
                        <FileHiddenAndLimitation
                          hiddenFile={cardData.hiddenFile}
                          setHiddenFile={setCardData}
                          setShowModal={setShowModal}
                          id={state.state.id}
                          new
                        />
                      ) : (
                        <></>
                      )}
                      {/* Hidden and Limitation */}

                      <div
                        className="w-100 d-flex align-items-center justify-content-md-end justify-content-center flex-wrap mt-4 mb-4 px-3"
                        style={{ gap: "10px" }}>
                        {cardData.detail.status === 4 ? (
                          <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap mt-4 mb-4 px-3">
                            <div className="d-flex flex-wrap align-items-center justify-content-center">
                              <div
                                className={`d-flex align-items-center border-success justify-content-center ms-md-4 ms-0 my-md-0 my-3 ${styles.border_blue}`}>
                                <svg width="22" height="20" viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg" className="ms-2">
                                  <path
                                    d="M33.9579 0.594854C15.4513 0.344894 0.34294 15.4533 0.592901 33.9599C0.839698 51.7087 15.2916 66.1606 33.0404 66.4074C51.5501 66.6605 66.6554 51.5521 66.4022 33.0455C66.1586 15.2935 51.7068 0.841651 33.9579 0.594854ZM31.3017 31.0442L39.4571 21.7102C39.8989 21.2046 40.5235 20.8953 41.1934 20.8502C41.8633 20.8051 42.5237 21.0279 43.0293 21.4698C43.5349 21.9116 43.8443 22.5361 43.8894 23.2061C43.9345 23.876 43.7116 24.5364 43.2698 25.042L35.1144 34.376C34.8956 34.6263 34.6297 34.8311 34.3318 34.9787C34.0339 35.1263 33.7098 35.2137 33.3781 35.236C33.0464 35.2584 32.7135 35.2151 32.3985 35.1088C32.0835 35.0025 31.7925 34.8352 31.5422 34.6164C31.2918 34.3977 31.087 34.1317 30.9395 33.8338C30.7919 33.5359 30.7044 33.2118 30.6821 32.8801C30.6598 32.5484 30.703 32.2156 30.8093 31.9005C30.9156 31.5855 31.0829 31.2946 31.3017 31.0442ZM25.1539 45.417C24.6793 45.8913 24.0357 46.1578 23.3647 46.1578C22.6936 46.1578 22.05 45.8913 21.5754 45.417L13.9895 37.8232C13.7546 37.588 13.5682 37.3089 13.4411 37.0017C13.3141 36.6945 13.2487 36.3653 13.2489 36.0328C13.249 35.7004 13.3146 35.3712 13.442 35.0641C13.5694 34.757 13.7559 34.4781 13.9911 34.2431C14.2263 34.0081 14.5055 33.8218 14.8127 33.6947C15.1199 33.5676 15.4491 33.5023 15.7815 33.5024C16.114 33.5025 16.4431 33.5682 16.7502 33.6955C17.0573 33.8229 17.3363 34.0095 17.5713 34.2447L25.165 41.8384C25.6379 42.3145 25.9024 42.9589 25.9003 43.63C25.8982 44.301 25.6298 44.9438 25.1539 45.417ZM53.1243 25.042L35.4245 45.292C35.1964 45.5533 34.9171 45.7649 34.6039 45.9138C34.2907 46.0626 33.9502 46.1455 33.6036 46.1574H33.5181C33.1855 46.1574 32.8562 46.0919 32.5489 45.9646C32.2416 45.8373 31.9624 45.6507 31.7273 45.4154L24.143 37.8216C23.6685 37.3467 23.402 36.7026 23.4023 36.0312C23.4026 35.3598 23.6696 34.716 24.1446 34.2415C24.6196 33.7669 25.2636 33.5005 25.935 33.5008C26.6064 33.5011 27.2502 33.7681 27.7247 34.2431L32.4392 38.9623C32.5618 39.0849 32.7082 39.181 32.8694 39.2446C33.0306 39.3083 33.2032 39.3382 33.3765 39.3324C33.5497 39.3266 33.72 39.2853 33.8766 39.211C34.0332 39.1367 34.1729 39.0311 34.287 38.9006L49.3163 21.7102C49.7581 21.2046 50.3827 20.8953 51.0526 20.8502C51.7225 20.8051 52.3829 21.0279 52.8885 21.4698C53.3941 21.9116 53.7035 22.5361 53.7486 23.2061C53.7937 23.876 53.5708 24.5364 53.129 25.042H53.1243Z"
                                    fill="#449114"
                                  />
                                </svg>

                                {btnLoader ? (
                                  <div className={styles.btn_loader_container}>
                                    <div className={styles.btn_spinner}></div>
                                  </div>
                                ) : (
                                  <div className={`text-success pointer ${styles.text_white}`} onClick={acceptPostHandler}>
                                    تایید
                                  </div>
                                )}
                              </div>

                              <button
                                className={`d-flex align-items-center justify-content-center ms-md-2 ms-0 my-md-0 my-3 border-danger ${styles.border_blue}`}
                                onClick={() =>
                                  setShowModal(prev => {
                                    return { ...prev, openRejectModal: true };
                                  })
                                }>
                                <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg" className="ms-3">
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7.1228 2C7.0738 1.99986 7.02526 2.0094 6.97997 2.02809C6.93467 2.04677 6.89352 2.07423 6.85887 2.10887C6.82422 2.14352 6.79677 2.18468 6.77808 2.22997C6.7594 2.27527 6.74985 2.32381 6.75 2.37281L6.75 2.375V3.50001H11.25V2.375L11.25 2.37281C11.2501 2.32381 11.2406 2.27527 11.2219 2.22997C11.2032 2.18467 11.1758 2.14352 11.1411 2.10887C11.1065 2.07423 11.0653 2.04677 11.02 2.02809C10.9747 2.0094 10.9262 1.99986 10.8772 2L10.875 2H7.125L7.1228 2ZM3.04834 5L3.93604 19.2032C3.93621 19.206 3.93637 19.2088 3.93651 19.2115C3.96245 19.7163 4.29756 20 4.6875 20H13.3125C13.6986 20 14.0322 19.7226 14.0639 19.2043L14.9517 5H3.04834ZM15.7431 3.50001H12.75V2.37612C12.7506 2.12977 12.7025 1.88572 12.6086 1.65798C12.5145 1.4299 12.3763 1.22267 12.2018 1.04821C12.0273 0.873754 11.8201 0.73551 11.592 0.641429C11.3643 0.547505 11.1203 0.499446 10.874 0.500005H7.12596C6.87966 0.499446 6.63567 0.547504 6.40797 0.641429C6.17989 0.73551 5.97267 0.873756 5.79821 1.04821C5.62375 1.22267 5.48551 1.4299 5.39142 1.65798C5.2975 1.88567 5.24944 2.12966 5.25 2.37596V3.50001H2.25693C2.25279 3.49997 2.24865 3.49997 2.24451 3.50001H0.75C0.335786 3.50001 0 3.83579 0 4.25001C0 4.66422 0.335786 5 0.75 5H1.54541L2.43872 19.293C2.50388 20.5196 3.42898 21.5 4.6875 21.5H13.3125C14.5829 21.5 15.4868 20.5109 15.5611 19.2959C15.5611 19.2958 15.5611 19.2958 15.5611 19.2958L16.4546 5H17.25C17.6642 5 18 4.66422 18 4.25001C18 3.83579 17.6642 3.50001 17.25 3.50001H15.7555C15.7513 3.49997 15.7472 3.49997 15.7431 3.50001ZM5.59823 6.50048C6.01218 6.4857 6.35974 6.80929 6.37452 7.22324L6.74952 17.7232C6.76431 18.1372 6.44072 18.4847 6.02677 18.4995C5.61282 18.5143 5.26526 18.1907 5.25048 17.7768L4.87548 7.27677C4.86069 6.86282 5.18428 6.51527 5.59823 6.50048ZM12.4018 6.50048C12.8157 6.51527 13.1393 6.86282 13.1245 7.27677L12.7495 17.7768C12.7347 18.1907 12.3872 18.5143 11.9732 18.4995C11.5593 18.4847 11.2357 18.1372 11.2505 17.7232L11.6255 7.22324C11.6403 6.80929 11.9878 6.4857 12.4018 6.50048ZM9 6.5C9.41421 6.5 9.75 6.83579 9.75 7.25V17.75C9.75 18.1642 9.41421 18.5 9 18.5C8.58579 18.5 8.25 18.1642 8.25 17.75V7.25C8.25 6.83579 8.58579 6.5 9 6.5Z"
                                    fill="#E00000"
                                  />
                                </svg>

                                <div className={`text-danger ${styles.text_blue}`}>رد</div>
                              </button>
                            </div>
                            <div className="d-flex flex-wrap align-items-center justify-content-center">
                              {archiveReqData ? (
                                <div
                                  className={`d-flex align-items-center justify-content-center ms-md-4 ms-0 my-md-0 my-3 border-danger pointer ${styles.border_blue}`}
                                  style={{ width: "300px", padding: "5px", textAlign: "center" }}
                                  onClick={removeArchiveRequestHandler}>
                                  <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg" className="ms-3">
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M7.1228 2C7.0738 1.99986 7.02526 2.0094 6.97997 2.02809C6.93467 2.04677 6.89352 2.07423 6.85887 2.10887C6.82422 2.14352 6.79677 2.18468 6.77808 2.22997C6.7594 2.27527 6.74985 2.32381 6.75 2.37281L6.75 2.375V3.50001H11.25V2.375L11.25 2.37281C11.2501 2.32381 11.2406 2.27527 11.2219 2.22997C11.2032 2.18467 11.1758 2.14352 11.1411 2.10887C11.1065 2.07423 11.0653 2.04677 11.02 2.02809C10.9747 2.0094 10.9262 1.99986 10.8772 2L10.875 2H7.125L7.1228 2ZM3.04834 5L3.93604 19.2032C3.93621 19.206 3.93637 19.2088 3.93651 19.2115C3.96245 19.7163 4.29756 20 4.6875 20H13.3125C13.6986 20 14.0322 19.7226 14.0639 19.2043L14.9517 5H3.04834ZM15.7431 3.50001H12.75V2.37612C12.7506 2.12977 12.7025 1.88572 12.6086 1.65798C12.5145 1.4299 12.3763 1.22267 12.2018 1.04821C12.0273 0.873754 11.8201 0.73551 11.592 0.641429C11.3643 0.547505 11.1203 0.499446 10.874 0.500005H7.12596C6.87966 0.499446 6.63567 0.547504 6.40797 0.641429C6.17989 0.73551 5.97267 0.873756 5.79821 1.04821C5.62375 1.22267 5.48551 1.4299 5.39142 1.65798C5.2975 1.88567 5.24944 2.12966 5.25 2.37596V3.50001H2.25693C2.25279 3.49997 2.24865 3.49997 2.24451 3.50001H0.75C0.335786 3.50001 0 3.83579 0 4.25001C0 4.66422 0.335786 5 0.75 5H1.54541L2.43872 19.293C2.50388 20.5196 3.42898 21.5 4.6875 21.5H13.3125C14.5829 21.5 15.4868 20.5109 15.5611 19.2959C15.5611 19.2958 15.5611 19.2958 15.5611 19.2958L16.4546 5H17.25C17.6642 5 18 4.66422 18 4.25001C18 3.83579 17.6642 3.50001 17.25 3.50001H15.7555C15.7513 3.49997 15.7472 3.49997 15.7431 3.50001ZM5.59823 6.50048C6.01218 6.4857 6.35974 6.80929 6.37452 7.22324L6.74952 17.7232C6.76431 18.1372 6.44072 18.4847 6.02677 18.4995C5.61282 18.5143 5.26526 18.1907 5.25048 17.7768L4.87548 7.27677C4.86069 6.86282 5.18428 6.51527 5.59823 6.50048ZM12.4018 6.50048C12.8157 6.51527 13.1393 6.86282 13.1245 7.27677L12.7495 17.7768C12.7347 18.1907 12.3872 18.5143 11.9732 18.4995C11.5593 18.4847 11.2357 18.1372 11.2505 17.7232L11.6255 7.22324C11.6403 6.80929 11.9878 6.4857 12.4018 6.50048ZM9 6.5C9.41421 6.5 9.75 6.83579 9.75 7.25V17.75C9.75 18.1642 9.41421 18.5 9 18.5C8.58579 18.5 8.25 18.1642 8.25 17.75V7.25C8.25 6.83579 8.58579 6.5 9 6.5Z"
                                      fill="#E00000"
                                    />
                                  </svg>

                                  <div className={`text-danger ${styles.text_blue}`}>
                                    درخواست آرشیو شما در حال حاضر {archiveReqData.isAccepted ? "قبول شده است" : "قبول نشده است"} (حذف)
                                  </div>
                                </div>
                              ) : cardData?.archiveData && permissions.find(i => i === 19 || i === 15) ? (
                                <div
                                  className={`d-flex align-items-center justify-content-center ms-md-4 ms-0 my-md-0 my-3 border-danger pointer ${styles.border_blue}`}
                                  onClick={removeArchiveHandler}>
                                  <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg" className="ms-3">
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M7.1228 2C7.0738 1.99986 7.02526 2.0094 6.97997 2.02809C6.93467 2.04677 6.89352 2.07423 6.85887 2.10887C6.82422 2.14352 6.79677 2.18468 6.77808 2.22997C6.7594 2.27527 6.74985 2.32381 6.75 2.37281L6.75 2.375V3.50001H11.25V2.375L11.25 2.37281C11.2501 2.32381 11.2406 2.27527 11.2219 2.22997C11.2032 2.18467 11.1758 2.14352 11.1411 2.10887C11.1065 2.07423 11.0653 2.04677 11.02 2.02809C10.9747 2.0094 10.9262 1.99986 10.8772 2L10.875 2H7.125L7.1228 2ZM3.04834 5L3.93604 19.2032C3.93621 19.206 3.93637 19.2088 3.93651 19.2115C3.96245 19.7163 4.29756 20 4.6875 20H13.3125C13.6986 20 14.0322 19.7226 14.0639 19.2043L14.9517 5H3.04834ZM15.7431 3.50001H12.75V2.37612C12.7506 2.12977 12.7025 1.88572 12.6086 1.65798C12.5145 1.4299 12.3763 1.22267 12.2018 1.04821C12.0273 0.873754 11.8201 0.73551 11.592 0.641429C11.3643 0.547505 11.1203 0.499446 10.874 0.500005H7.12596C6.87966 0.499446 6.63567 0.547504 6.40797 0.641429C6.17989 0.73551 5.97267 0.873756 5.79821 1.04821C5.62375 1.22267 5.48551 1.4299 5.39142 1.65798C5.2975 1.88567 5.24944 2.12966 5.25 2.37596V3.50001H2.25693C2.25279 3.49997 2.24865 3.49997 2.24451 3.50001H0.75C0.335786 3.50001 0 3.83579 0 4.25001C0 4.66422 0.335786 5 0.75 5H1.54541L2.43872 19.293C2.50388 20.5196 3.42898 21.5 4.6875 21.5H13.3125C14.5829 21.5 15.4868 20.5109 15.5611 19.2959C15.5611 19.2958 15.5611 19.2958 15.5611 19.2958L16.4546 5H17.25C17.6642 5 18 4.66422 18 4.25001C18 3.83579 17.6642 3.50001 17.25 3.50001H15.7555C15.7513 3.49997 15.7472 3.49997 15.7431 3.50001ZM5.59823 6.50048C6.01218 6.4857 6.35974 6.80929 6.37452 7.22324L6.74952 17.7232C6.76431 18.1372 6.44072 18.4847 6.02677 18.4995C5.61282 18.5143 5.26526 18.1907 5.25048 17.7768L4.87548 7.27677C4.86069 6.86282 5.18428 6.51527 5.59823 6.50048ZM12.4018 6.50048C12.8157 6.51527 13.1393 6.86282 13.1245 7.27677L12.7495 17.7768C12.7347 18.1907 12.3872 18.5143 11.9732 18.4995C11.5593 18.4847 11.2357 18.1372 11.2505 17.7232L11.6255 7.22324C11.6403 6.80929 11.9878 6.4857 12.4018 6.50048ZM9 6.5C9.41421 6.5 9.75 6.83579 9.75 7.25V17.75C9.75 18.1642 9.41421 18.5 9 18.5C8.58579 18.5 8.25 18.1642 8.25 17.75V7.25C8.25 6.83579 8.58579 6.5 9 6.5Z"
                                      fill="#E00000"
                                    />
                                  </svg>

                                  <div className={`text-danger ${styles.text_blue}`}>حذف آرشیو</div>
                                </div>
                              ) : permissions.find(i => i === 19 || i === 15) ? (
                                <div
                                  className={`d-flex align-items-center justify-content-center ms-md-4 ms-0 my-md-0 my-3 ${styles.filled_blue}`}
                                  onClick={() =>
                                    setShowModal(prev => {
                                      return { ...prev, openArchive: true };
                                    })
                                  }>
                                  <svg width="22" height="20" viewBox="0 0 22 20" fill="none" className="ms-3" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M2.5625 1.75C2.25184 1.75 2 2.00184 2 2.3125V3.4375C2 3.74816 2.25184 4 2.5625 4H19.4375C19.7482 4 20 3.74816 20 3.4375V2.3125C20 2.00184 19.7482 1.75 19.4375 1.75H2.5625ZM0.5 2.3125C0.5 1.17341 1.42341 0.25 2.5625 0.25H19.4375C20.5766 0.25 21.5 1.17341 21.5 2.3125V3.4375C21.5 4.38158 20.8657 5.17751 20 5.42236V17.125L20 17.1272C19.9979 17.8222 19.7209 18.4881 19.2295 18.9795C18.7381 19.4709 18.0722 19.7479 17.3772 19.75L17.375 19.75H4.625L4.62276 19.75C3.9278 19.7479 3.2619 19.4709 2.77048 18.9795C2.27907 18.4881 2.00208 17.8222 2 17.1272L2 17.125V5.42236C1.13431 5.17751 0.5 4.38158 0.5 3.4375V2.3125ZM3.5 5.5V17.1238C3.50115 17.4221 3.62017 17.7079 3.83114 17.9189C4.04215 18.1299 4.32801 18.2489 4.62639 18.25H17.3736C17.672 18.2489 17.9579 18.1299 18.1689 17.9189C18.3799 17.7079 18.4989 17.422 18.5 17.1236V5.5H3.5ZM11 7.75C11.4142 7.75 11.75 8.08579 11.75 8.5V13.4393L13.4697 11.7197C13.7626 11.4268 14.2374 11.4268 14.5303 11.7197C14.8232 12.0126 14.8232 12.4874 14.5303 12.7803L11.5303 15.7803C11.2374 16.0732 10.7626 16.0732 10.4697 15.7803L7.46967 12.7803C7.17678 12.4874 7.17678 12.0126 7.46967 11.7197C7.76256 11.4268 8.23744 11.4268 8.53033 11.7197L10.25 13.4393V8.5C10.25 8.08579 10.5858 7.75 11 7.75Z"
                                      fill="white"
                                    />
                                  </svg>

                                  <div className={styles.text_white}>آرشیو</div>
                                </div>
                              ) : (
                                <div
                                  className={`d-flex align-items-center justify-content-center ms-md-4 ms-0 my-md-0 my-3 ${styles.filled_blue}`}
                                  onClick={() =>
                                    setShowModal(prev => {
                                      return { ...prev, openArchiveRequest: true };
                                    })
                                  }>
                                  <svg width="22" height="20" viewBox="0 0 22 20" fill="none" className="ms-3" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M2.5625 1.75C2.25184 1.75 2 2.00184 2 2.3125V3.4375C2 3.74816 2.25184 4 2.5625 4H19.4375C19.7482 4 20 3.74816 20 3.4375V2.3125C20 2.00184 19.7482 1.75 19.4375 1.75H2.5625ZM0.5 2.3125C0.5 1.17341 1.42341 0.25 2.5625 0.25H19.4375C20.5766 0.25 21.5 1.17341 21.5 2.3125V3.4375C21.5 4.38158 20.8657 5.17751 20 5.42236V17.125L20 17.1272C19.9979 17.8222 19.7209 18.4881 19.2295 18.9795C18.7381 19.4709 18.0722 19.7479 17.3772 19.75L17.375 19.75H4.625L4.62276 19.75C3.9278 19.7479 3.2619 19.4709 2.77048 18.9795C2.27907 18.4881 2.00208 17.8222 2 17.1272L2 17.125V5.42236C1.13431 5.17751 0.5 4.38158 0.5 3.4375V2.3125ZM3.5 5.5V17.1238C3.50115 17.4221 3.62017 17.7079 3.83114 17.9189C4.04215 18.1299 4.32801 18.2489 4.62639 18.25H17.3736C17.672 18.2489 17.9579 18.1299 18.1689 17.9189C18.3799 17.7079 18.4989 17.422 18.5 17.1236V5.5H3.5ZM11 7.75C11.4142 7.75 11.75 8.08579 11.75 8.5V13.4393L13.4697 11.7197C13.7626 11.4268 14.2374 11.4268 14.5303 11.7197C14.8232 12.0126 14.8232 12.4874 14.5303 12.7803L11.5303 15.7803C11.2374 16.0732 10.7626 16.0732 10.4697 15.7803L7.46967 12.7803C7.17678 12.4874 7.17678 12.0126 7.46967 11.7197C7.76256 11.4268 8.23744 11.4268 8.53033 11.7197L10.25 13.4393V8.5C10.25 8.08579 10.5858 7.75 11 7.75Z"
                                      fill="white"
                                    />
                                  </svg>

                                  <div className={styles.text_white}>درخواست آرشیو</div>
                                </div>
                              )}
                              {permissions?.find(item => item === 19) === 19 ? (
                                <div
                                  className={`d-flex align-items-center justify-content-center ms-md-4 ms-0 my-md-0 my-3 pointer ${styles.border_blue}`}
                                  onClick={() => {
                                    setShowLogs(true);
                                  }}>
                                  <div className={`${styles.text_blue}`}>تاریخچه</div>
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div
                            className="d-flex align-items-center justify-content-md-end justify-content-center flex-wrap mt-4 mb-4 px-3"
                            style={{ gap: "10px" }}>
                            {archiveReqData ? (
                              <div
                                className={`d-flex align-items-center justify-content-center ms-md-4 ms-0 my-md-0 my-3 border-danger pointer ${styles.border_blue}`}
                                style={{ width: "300px", padding: "5px", textAlign: "center" }}
                                onClick={removeArchiveRequestHandler}>
                                <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg" className="ms-3">
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7.1228 2C7.0738 1.99986 7.02526 2.0094 6.97997 2.02809C6.93467 2.04677 6.89352 2.07423 6.85887 2.10887C6.82422 2.14352 6.79677 2.18468 6.77808 2.22997C6.7594 2.27527 6.74985 2.32381 6.75 2.37281L6.75 2.375V3.50001H11.25V2.375L11.25 2.37281C11.2501 2.32381 11.2406 2.27527 11.2219 2.22997C11.2032 2.18467 11.1758 2.14352 11.1411 2.10887C11.1065 2.07423 11.0653 2.04677 11.02 2.02809C10.9747 2.0094 10.9262 1.99986 10.8772 2L10.875 2H7.125L7.1228 2ZM3.04834 5L3.93604 19.2032C3.93621 19.206 3.93637 19.2088 3.93651 19.2115C3.96245 19.7163 4.29756 20 4.6875 20H13.3125C13.6986 20 14.0322 19.7226 14.0639 19.2043L14.9517 5H3.04834ZM15.7431 3.50001H12.75V2.37612C12.7506 2.12977 12.7025 1.88572 12.6086 1.65798C12.5145 1.4299 12.3763 1.22267 12.2018 1.04821C12.0273 0.873754 11.8201 0.73551 11.592 0.641429C11.3643 0.547505 11.1203 0.499446 10.874 0.500005H7.12596C6.87966 0.499446 6.63567 0.547504 6.40797 0.641429C6.17989 0.73551 5.97267 0.873756 5.79821 1.04821C5.62375 1.22267 5.48551 1.4299 5.39142 1.65798C5.2975 1.88567 5.24944 2.12966 5.25 2.37596V3.50001H2.25693C2.25279 3.49997 2.24865 3.49997 2.24451 3.50001H0.75C0.335786 3.50001 0 3.83579 0 4.25001C0 4.66422 0.335786 5 0.75 5H1.54541L2.43872 19.293C2.50388 20.5196 3.42898 21.5 4.6875 21.5H13.3125C14.5829 21.5 15.4868 20.5109 15.5611 19.2959C15.5611 19.2958 15.5611 19.2958 15.5611 19.2958L16.4546 5H17.25C17.6642 5 18 4.66422 18 4.25001C18 3.83579 17.6642 3.50001 17.25 3.50001H15.7555C15.7513 3.49997 15.7472 3.49997 15.7431 3.50001ZM5.59823 6.50048C6.01218 6.4857 6.35974 6.80929 6.37452 7.22324L6.74952 17.7232C6.76431 18.1372 6.44072 18.4847 6.02677 18.4995C5.61282 18.5143 5.26526 18.1907 5.25048 17.7768L4.87548 7.27677C4.86069 6.86282 5.18428 6.51527 5.59823 6.50048ZM12.4018 6.50048C12.8157 6.51527 13.1393 6.86282 13.1245 7.27677L12.7495 17.7768C12.7347 18.1907 12.3872 18.5143 11.9732 18.4995C11.5593 18.4847 11.2357 18.1372 11.2505 17.7232L11.6255 7.22324C11.6403 6.80929 11.9878 6.4857 12.4018 6.50048ZM9 6.5C9.41421 6.5 9.75 6.83579 9.75 7.25V17.75C9.75 18.1642 9.41421 18.5 9 18.5C8.58579 18.5 8.25 18.1642 8.25 17.75V7.25C8.25 6.83579 8.58579 6.5 9 6.5Z"
                                    fill="#E00000"
                                  />
                                </svg>

                                <div className={`text-danger ${styles.text_blue}`}>
                                  درخواست آرشیو شما در حال حاضر {archiveReqData.isAccepted ? "قبول شده است" : "قبول نشده است"} (حذف)
                                </div>
                              </div>
                            ) : cardData?.archiveData && permissions.find(i => i === 19 || i === 15) ? (
                              <div
                                className={`d-flex align-items-center justify-content-center ms-md-4 ms-0 my-md-0 my-3 border-danger pointer ${styles.border_blue}`}
                                onClick={removeArchiveHandler}>
                                <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg" className="ms-3">
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7.1228 2C7.0738 1.99986 7.02526 2.0094 6.97997 2.02809C6.93467 2.04677 6.89352 2.07423 6.85887 2.10887C6.82422 2.14352 6.79677 2.18468 6.77808 2.22997C6.7594 2.27527 6.74985 2.32381 6.75 2.37281L6.75 2.375V3.50001H11.25V2.375L11.25 2.37281C11.2501 2.32381 11.2406 2.27527 11.2219 2.22997C11.2032 2.18467 11.1758 2.14352 11.1411 2.10887C11.1065 2.07423 11.0653 2.04677 11.02 2.02809C10.9747 2.0094 10.9262 1.99986 10.8772 2L10.875 2H7.125L7.1228 2ZM3.04834 5L3.93604 19.2032C3.93621 19.206 3.93637 19.2088 3.93651 19.2115C3.96245 19.7163 4.29756 20 4.6875 20H13.3125C13.6986 20 14.0322 19.7226 14.0639 19.2043L14.9517 5H3.04834ZM15.7431 3.50001H12.75V2.37612C12.7506 2.12977 12.7025 1.88572 12.6086 1.65798C12.5145 1.4299 12.3763 1.22267 12.2018 1.04821C12.0273 0.873754 11.8201 0.73551 11.592 0.641429C11.3643 0.547505 11.1203 0.499446 10.874 0.500005H7.12596C6.87966 0.499446 6.63567 0.547504 6.40797 0.641429C6.17989 0.73551 5.97267 0.873756 5.79821 1.04821C5.62375 1.22267 5.48551 1.4299 5.39142 1.65798C5.2975 1.88567 5.24944 2.12966 5.25 2.37596V3.50001H2.25693C2.25279 3.49997 2.24865 3.49997 2.24451 3.50001H0.75C0.335786 3.50001 0 3.83579 0 4.25001C0 4.66422 0.335786 5 0.75 5H1.54541L2.43872 19.293C2.50388 20.5196 3.42898 21.5 4.6875 21.5H13.3125C14.5829 21.5 15.4868 20.5109 15.5611 19.2959C15.5611 19.2958 15.5611 19.2958 15.5611 19.2958L16.4546 5H17.25C17.6642 5 18 4.66422 18 4.25001C18 3.83579 17.6642 3.50001 17.25 3.50001H15.7555C15.7513 3.49997 15.7472 3.49997 15.7431 3.50001ZM5.59823 6.50048C6.01218 6.4857 6.35974 6.80929 6.37452 7.22324L6.74952 17.7232C6.76431 18.1372 6.44072 18.4847 6.02677 18.4995C5.61282 18.5143 5.26526 18.1907 5.25048 17.7768L4.87548 7.27677C4.86069 6.86282 5.18428 6.51527 5.59823 6.50048ZM12.4018 6.50048C12.8157 6.51527 13.1393 6.86282 13.1245 7.27677L12.7495 17.7768C12.7347 18.1907 12.3872 18.5143 11.9732 18.4995C11.5593 18.4847 11.2357 18.1372 11.2505 17.7232L11.6255 7.22324C11.6403 6.80929 11.9878 6.4857 12.4018 6.50048ZM9 6.5C9.41421 6.5 9.75 6.83579 9.75 7.25V17.75C9.75 18.1642 9.41421 18.5 9 18.5C8.58579 18.5 8.25 18.1642 8.25 17.75V7.25C8.25 6.83579 8.58579 6.5 9 6.5Z"
                                    fill="#E00000"
                                  />
                                </svg>

                                <div className={`text-danger ${styles.text_blue}`}>حذف آرشیو</div>
                              </div>
                            ) : permissions.find(i => i === 19 || i === 15) ? (
                              <div
                                className={`d-flex align-items-center justify-content-center ms-md-4 ms-0 my-md-0 my-3 ${styles.filled_blue}`}
                                onClick={() =>
                                  setShowModal(prev => {
                                    return { ...prev, openArchive: true };
                                  })
                                }>
                                <svg width="22" height="20" viewBox="0 0 22 20" fill="none" className="ms-3" xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M2.5625 1.75C2.25184 1.75 2 2.00184 2 2.3125V3.4375C2 3.74816 2.25184 4 2.5625 4H19.4375C19.7482 4 20 3.74816 20 3.4375V2.3125C20 2.00184 19.7482 1.75 19.4375 1.75H2.5625ZM0.5 2.3125C0.5 1.17341 1.42341 0.25 2.5625 0.25H19.4375C20.5766 0.25 21.5 1.17341 21.5 2.3125V3.4375C21.5 4.38158 20.8657 5.17751 20 5.42236V17.125L20 17.1272C19.9979 17.8222 19.7209 18.4881 19.2295 18.9795C18.7381 19.4709 18.0722 19.7479 17.3772 19.75L17.375 19.75H4.625L4.62276 19.75C3.9278 19.7479 3.2619 19.4709 2.77048 18.9795C2.27907 18.4881 2.00208 17.8222 2 17.1272L2 17.125V5.42236C1.13431 5.17751 0.5 4.38158 0.5 3.4375V2.3125ZM3.5 5.5V17.1238C3.50115 17.4221 3.62017 17.7079 3.83114 17.9189C4.04215 18.1299 4.32801 18.2489 4.62639 18.25H17.3736C17.672 18.2489 17.9579 18.1299 18.1689 17.9189C18.3799 17.7079 18.4989 17.422 18.5 17.1236V5.5H3.5ZM11 7.75C11.4142 7.75 11.75 8.08579 11.75 8.5V13.4393L13.4697 11.7197C13.7626 11.4268 14.2374 11.4268 14.5303 11.7197C14.8232 12.0126 14.8232 12.4874 14.5303 12.7803L11.5303 15.7803C11.2374 16.0732 10.7626 16.0732 10.4697 15.7803L7.46967 12.7803C7.17678 12.4874 7.17678 12.0126 7.46967 11.7197C7.76256 11.4268 8.23744 11.4268 8.53033 11.7197L10.25 13.4393V8.5C10.25 8.08579 10.5858 7.75 11 7.75Z"
                                    fill="white"
                                  />
                                </svg>

                                <div className={styles.text_white}>آرشیو</div>
                              </div>
                            ) : (
                              <div
                                className={`d-flex align-items-center justify-content-center ms-md-4 ms-0 my-md-0 my-3 ${styles.filled_blue}`}
                                onClick={() =>
                                  setShowModal(prev => {
                                    return { ...prev, openArchiveRequest: true };
                                  })
                                }>
                                <svg width="22" height="20" viewBox="0 0 22 20" fill="none" className="ms-3" xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M2.5625 1.75C2.25184 1.75 2 2.00184 2 2.3125V3.4375C2 3.74816 2.25184 4 2.5625 4H19.4375C19.7482 4 20 3.74816 20 3.4375V2.3125C20 2.00184 19.7482 1.75 19.4375 1.75H2.5625ZM0.5 2.3125C0.5 1.17341 1.42341 0.25 2.5625 0.25H19.4375C20.5766 0.25 21.5 1.17341 21.5 2.3125V3.4375C21.5 4.38158 20.8657 5.17751 20 5.42236V17.125L20 17.1272C19.9979 17.8222 19.7209 18.4881 19.2295 18.9795C18.7381 19.4709 18.0722 19.7479 17.3772 19.75L17.375 19.75H4.625L4.62276 19.75C3.9278 19.7479 3.2619 19.4709 2.77048 18.9795C2.27907 18.4881 2.00208 17.8222 2 17.1272L2 17.125V5.42236C1.13431 5.17751 0.5 4.38158 0.5 3.4375V2.3125ZM3.5 5.5V17.1238C3.50115 17.4221 3.62017 17.7079 3.83114 17.9189C4.04215 18.1299 4.32801 18.2489 4.62639 18.25H17.3736C17.672 18.2489 17.9579 18.1299 18.1689 17.9189C18.3799 17.7079 18.4989 17.422 18.5 17.1236V5.5H3.5ZM11 7.75C11.4142 7.75 11.75 8.08579 11.75 8.5V13.4393L13.4697 11.7197C13.7626 11.4268 14.2374 11.4268 14.5303 11.7197C14.8232 12.0126 14.8232 12.4874 14.5303 12.7803L11.5303 15.7803C11.2374 16.0732 10.7626 16.0732 10.4697 15.7803L7.46967 12.7803C7.17678 12.4874 7.17678 12.0126 7.46967 11.7197C7.76256 11.4268 8.23744 11.4268 8.53033 11.7197L10.25 13.4393V8.5C10.25 8.08579 10.5858 7.75 11 7.75Z"
                                    fill="white"
                                  />
                                </svg>

                                <div className={styles.text_white}>درخواست آرشیو</div>
                              </div>
                            )}
                            {/*cardData?.archiveData ?
                                                                <div className={`d-flex align-items-center justify-content-center ms-md-4 ms-0 my-md-0 my-3 border-danger pointer ${styles.border_blue}`} onClick={removeArchiveHandler}>
                                                                    <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg" className='ms-3'>
                                                                        <path fillRule="evenodd" clipRule="evenodd" d="M7.1228 2C7.0738 1.99986 7.02526 2.0094 6.97997 2.02809C6.93467 2.04677 6.89352 2.07423 6.85887 2.10887C6.82422 2.14352 6.79677 2.18468 6.77808 2.22997C6.7594 2.27527 6.74985 2.32381 6.75 2.37281L6.75 2.375V3.50001H11.25V2.375L11.25 2.37281C11.2501 2.32381 11.2406 2.27527 11.2219 2.22997C11.2032 2.18467 11.1758 2.14352 11.1411 2.10887C11.1065 2.07423 11.0653 2.04677 11.02 2.02809C10.9747 2.0094 10.9262 1.99986 10.8772 2L10.875 2H7.125L7.1228 2ZM3.04834 5L3.93604 19.2032C3.93621 19.206 3.93637 19.2088 3.93651 19.2115C3.96245 19.7163 4.29756 20 4.6875 20H13.3125C13.6986 20 14.0322 19.7226 14.0639 19.2043L14.9517 5H3.04834ZM15.7431 3.50001H12.75V2.37612C12.7506 2.12977 12.7025 1.88572 12.6086 1.65798C12.5145 1.4299 12.3763 1.22267 12.2018 1.04821C12.0273 0.873754 11.8201 0.73551 11.592 0.641429C11.3643 0.547505 11.1203 0.499446 10.874 0.500005H7.12596C6.87966 0.499446 6.63567 0.547504 6.40797 0.641429C6.17989 0.73551 5.97267 0.873756 5.79821 1.04821C5.62375 1.22267 5.48551 1.4299 5.39142 1.65798C5.2975 1.88567 5.24944 2.12966 5.25 2.37596V3.50001H2.25693C2.25279 3.49997 2.24865 3.49997 2.24451 3.50001H0.75C0.335786 3.50001 0 3.83579 0 4.25001C0 4.66422 0.335786 5 0.75 5H1.54541L2.43872 19.293C2.50388 20.5196 3.42898 21.5 4.6875 21.5H13.3125C14.5829 21.5 15.4868 20.5109 15.5611 19.2959C15.5611 19.2958 15.5611 19.2958 15.5611 19.2958L16.4546 5H17.25C17.6642 5 18 4.66422 18 4.25001C18 3.83579 17.6642 3.50001 17.25 3.50001H15.7555C15.7513 3.49997 15.7472 3.49997 15.7431 3.50001ZM5.59823 6.50048C6.01218 6.4857 6.35974 6.80929 6.37452 7.22324L6.74952 17.7232C6.76431 18.1372 6.44072 18.4847 6.02677 18.4995C5.61282 18.5143 5.26526 18.1907 5.25048 17.7768L4.87548 7.27677C4.86069 6.86282 5.18428 6.51527 5.59823 6.50048ZM12.4018 6.50048C12.8157 6.51527 13.1393 6.86282 13.1245 7.27677L12.7495 17.7768C12.7347 18.1907 12.3872 18.5143 11.9732 18.4995C11.5593 18.4847 11.2357 18.1372 11.2505 17.7232L11.6255 7.22324C11.6403 6.80929 11.9878 6.4857 12.4018 6.50048ZM9 6.5C9.41421 6.5 9.75 6.83579 9.75 7.25V17.75C9.75 18.1642 9.41421 18.5 9 18.5C8.58579 18.5 8.25 18.1642 8.25 17.75V7.25C8.25 6.83579 8.58579 6.5 9 6.5Z" fill="#E00000" />
                                                                    </svg>

                                                                    <div className={`text-danger ${styles.text_blue}`}>
                                                                        حذف آرشیو
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className={`d-flex align-items-center justify-content-center ms-md-4 ms-0 my-md-0 my-3 ${styles.filled_blue}`} onClick={() => setShowModal((prev) => {
                                                                    return { ...prev, openArchiveRequest: true };
                                                                })}>
                                                                    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" className='ms-3' xmlns="http://www.w3.org/2000/svg">
                                                                        <path fillRule="evenodd" clipRule="evenodd" d="M2.5625 1.75C2.25184 1.75 2 2.00184 2 2.3125V3.4375C2 3.74816 2.25184 4 2.5625 4H19.4375C19.7482 4 20 3.74816 20 3.4375V2.3125C20 2.00184 19.7482 1.75 19.4375 1.75H2.5625ZM0.5 2.3125C0.5 1.17341 1.42341 0.25 2.5625 0.25H19.4375C20.5766 0.25 21.5 1.17341 21.5 2.3125V3.4375C21.5 4.38158 20.8657 5.17751 20 5.42236V17.125L20 17.1272C19.9979 17.8222 19.7209 18.4881 19.2295 18.9795C18.7381 19.4709 18.0722 19.7479 17.3772 19.75L17.375 19.75H4.625L4.62276 19.75C3.9278 19.7479 3.2619 19.4709 2.77048 18.9795C2.27907 18.4881 2.00208 17.8222 2 17.1272L2 17.125V5.42236C1.13431 5.17751 0.5 4.38158 0.5 3.4375V2.3125ZM3.5 5.5V17.1238C3.50115 17.4221 3.62017 17.7079 3.83114 17.9189C4.04215 18.1299 4.32801 18.2489 4.62639 18.25H17.3736C17.672 18.2489 17.9579 18.1299 18.1689 17.9189C18.3799 17.7079 18.4989 17.422 18.5 17.1236V5.5H3.5ZM11 7.75C11.4142 7.75 11.75 8.08579 11.75 8.5V13.4393L13.4697 11.7197C13.7626 11.4268 14.2374 11.4268 14.5303 11.7197C14.8232 12.0126 14.8232 12.4874 14.5303 12.7803L11.5303 15.7803C11.2374 16.0732 10.7626 16.0732 10.4697 15.7803L7.46967 12.7803C7.17678 12.4874 7.17678 12.0126 7.46967 11.7197C7.76256 11.4268 8.23744 11.4268 8.53033 11.7197L10.25 13.4393V8.5C10.25 8.08579 10.5858 7.75 11 7.75Z" fill="white" />
                                                                    </svg>

                                                                    <div className={styles.text_white}>
                                                                        درخواست آرشیو
                                                                    </div>
                                                                </div>
                                                            */}

                            {cardData.detail.userId == userData.id || permissions?.find(item => item === 19) === 19 ? (
                              <>
                                <Link
                                  to={{
                                    pathname: `/edit-card-category/${state.state.id}`,
                                    state: {
                                      state: cardData?.detail,
                                      pageNumber: state.pageNumber,
                                      data: state,
                                    },
                                  }}
                                  className={`d-flex align-items-center justify-content-center ms-md-2 ms-0 my-md-0 my-3 ${styles.border_blue}`}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    fill="#21409A"
                                    className="ms-3 bi bi-pencil-square"
                                    viewBox="0 0 16 16">
                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                    <path
                                      fillRule="evenodd"
                                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                    />
                                  </svg>
                                  <div className={styles.text_blue}>تغییر منطقه</div>
                                </Link>
                                <Link
                                  to={{
                                    pathname: `/add-multiple/${cardData.detail.slug}`,
                                    state: cardData.detail,
                                  }}
                                  className={`d-flex align-items-center justify-content-center ms-md-2 ms-0 my-md-0 my-3 ${styles.border_blue}`}>
                                  <div className={styles.text_blue}>افزودن زیرمجموعه</div>
                                </Link>
                                <Link
                                  to={{
                                    pathname: cardData.detail.estateRegion == "1" ? `/edit-card/${state.state.id}` : `/edit-card-region/${state.state.id}`,
                                    state: {
                                      state: cardData?.detail,
                                      pageNumber: state.pageNumber,
                                      data: state,
                                    },
                                  }}
                                  className={`d-flex align-items-center justify-content-center ms-md-2 ms-0 my-md-0 my-3 ${styles.border_blue}`}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    fill="#21409A"
                                    className="ms-3 bi bi-pencil-square"
                                    viewBox="0 0 16 16">
                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                    <path
                                      fillRule="evenodd"
                                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                    />
                                  </svg>
                                  <div className={styles.text_blue}>ویرایش</div>
                                </Link>
                              </>
                            ) : (
                              <></>
                            )}
                            {permissions?.find(item => item === 19) === 19 ? (
                              <div
                                className={`d-flex align-items-center justify-content-center ms-md-4 ms-0 my-md-0 my-3 pointer ${styles.border_blue}`}
                                onClick={() => {
                                  setShowLogs(true);
                                }}>
                                <div className={`${styles.text_blue}`}>تاریخچه</div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={isShowSidebar ? "col-md-3" : "hidden"}
              style={{
                display: isShowSidebar ? "block" : "none",
              }}>
              {/* sideMenu starts */}
              <DashboardSideMenu setIsShowSidebar={setIsShowSidebar} isShowSidebar={isShowSidebar} />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    }
  }

  function backHandler() {
    if (state.isArchive) {
      // const data = state.pageNumber;
      const data = {
        pageNumber: state.pageNumber,
        query: state.query,
      };
      history.push("/archive-files", data);
    } else {
      // const data = state.pageNumber;
      const data = {
        pageNumber: state.pageNumber,
        query: state.query,
      };
      history.push("/FileManagement", data);
    }
  }

  async function saveCardHandler() {
    notify("درحال ذخیره فایل", "success");
    try {
      var saveData = new FormData();
      saveData.append("estateId", state.state.id);

      const addSave = await axios.post(`Estate/SaveEstate?estateId=${state.state.id}`, saveData, {
        headers: { authorization: "Bearer " + userToken },
      });
      notify("فایل با موفقیت ذخیره شد", "success");
      if (addSave.data.isSuccess === true) {
        // setSaveCard(true)
        window.location.reload(false);
      }
    } catch (error) {
      notify("خطای سرور", "error");
    }
  }

  async function removeSaveHandler() {
    notify("درحال حذف ذخیره فایل", "success");
    try {
      var saveData = new FormData();
      saveData.append("estateId", state.state.id);

      const removeSave = await axios.post(`Estate/RemoveFromSaveList?estateId=${state.state.id}`, saveData, {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(removeSave.data)
      if (removeSave.data.isSuccess === true) {
        // setSaveCard(false)
        window.location.reload(false);
      }
    } catch (error) {
      notify("خطای سرور", "error");
    }
  }

  async function removeArchiveHandler() {
    notify("درحال حذف آرشیو فایل", "success");
    try {
      const deleteArchive = await axios.delete(`Archive/${state.state.id}`, {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(deleteArchive)
      // setSaveCard(false)
      history.push("/archive-files");
    } catch (error) {
      notify("خطای سرور", "error");
    }
  }

  async function archiveReminderHandle() {
    try {
      let reminderId = cardData?.detail?.archiveDetails?.reminder?.id;

      var data = {
        reminderId: reminderId,
      };

      const postApiData = await axios.delete("Reminder/DeleteReminder", {
        data: data,
        headers: {
          authorization: "Bearer " + userToken,
        },
      });

      notify("یادآوری با موفقیت حذف شد", "success");
    } catch (e) {
      notify("مشکلی در سرور به وجود امد", "error");
    }
  }

  async function reminderHandler() {
    try {
      notify("درحال حذف یادآور", "success");
      var data = {
        reminderId: cardData.reminder?.id,
      };

      const postApiData = await axios.delete("Reminder/DeleteReminder", {
        data: data,
        headers: {
          authorization: "Bearer " + userToken,
        },
      });
      // console.log(postApiData)
      notify("یادآور حذف شد", "success");
      window.location.reload(false);
    } catch (error) {
      notify("خطای سرور", "error");
    }
  }

  async function acceptPostHandler() {
    notify("درحال تایید فایل", "success");
    // setBtnLoader(true)
    try {
      var saveData = {
        estateId: cardData.detail.id,
      };

      const addSave = await axios.post(`Estate/AcceptEstate`, saveData, {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(addSave)
      notify("فایل با موفقیت تایید شد", "success");
      // setBtnLoader(false)
      // if (addSave.data.isSuccess === true) {
      // setSaveCard(true)
      history.push("/FileManagement");
      // }
    } catch (error) {
      notify("خطای سرور", "error");
    }
  }
};

export default React.memo(CardDetail);
